import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/ping/")({
    component: PingsReportPage,
    staticData: {
        permissions: [],
        showInSideMenu: false,
        label: "pages.report.ping.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.report.ping.title"),
        };
    },
});

function PingsReportPage() {
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <></>
        </TenantPage>
    );
}
